const solBreakpoints = {
  values: {
    xs: 360, // check if we support 360 or 320 ???
    sm: 768,
    md: 1024,
    lg: 1200,
    xl: 1441,
  },
};

export default solBreakpoints;
